'use strict';

var Reflux    = require('reflux'),
    ApplicationActions = require('js/shared/actions/application-actions.js');

/**
 * This store handles all notifications within the application (growls).
 *
 */
module.exports = Reflux.createStore({

    init: function () {

        // listenables

    },

    notify: function (message, type) {
        alert(message); // TODO someone use a real notification thing
    },

    genericSuccess: function (/* resp */) {
        this.notify('Saved Changes.', 'success');
    },

    onCreateUserFailed: function (resp) {
        this.notify(resp.body.message);
    },

    onAuthUserFailed: function (resp) {
        this.notify(resp.body.message);
    },

    onCreateClaimFailed: function (resp) {
        this.notify(resp.body.message);
    },

    onSubmitApplicationSuccessFailed: function (resp) {
        this.notify(resp.body.message);
    },


});



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/stores/notification-store.js
 ** module id = 196
 ** module chunks = 0 1 6
 **/